import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

//styles
import { Error } from './index.styled';

const ErrorField = ({ children, isPassword, checkbox }) => {
  const { t } = useTranslation();

  return (
    <>
      {children !== 'Required' && (
        <Error checkbox={checkbox} isPassword={isPassword}>
          {t(children)}
        </Error>
      )}
    </>
  );
};

ErrorField.propTypes = {
  children: PropTypes.node,
  isPassword: PropTypes.bool,
  checkbox: PropTypes.bool,
};

export default ErrorField;
